import { Controller } from "@hotwired/stimulus"
import Tribute from "tributejs"

export default class extends Controller {
  static targets = ["content"]
  static values = { placeholders: Array }

  connect() {
    // Initialize Tribute.js for autocomplete
    this.initializeTribute();
  }

  initializeTribute() {
    // Check if content target exists
    if (!this.contentTarget) {
      return;
    }
    
    // Get placeholders from backend data
    const placeholders = this.placeholdersValue || [];

    // Initialize Tribute
    this.tribute = new Tribute({
      trigger: '#',
      values: placeholders,
      selectTemplate: function(item) {
        return '{{ ' + item.original.key + ' }}';
      },
      menuItemTemplate: function(item) {
        return '<div class="tribute-item"><strong>' + item.original.label + '</strong><small class="text-muted">' + item.original.example + '</small></div>';
      },
      lookup: function(item) {
        return item.key + ' ' + item.label;
      },
      fillAttr: 'key',
      requireLeadingSpace: false,
      allowSpaces: true,
      menuItemLimit: 10,
      noMatchTemplate: '<div class="tribute-item">Keine passenden Platzhalter gefunden</div>'
    });

    // Attach to content field
    this.tribute.attach(this.contentTarget);
  }

  disconnect() {
    // Clean up Tribute instance
    if (this.tribute) {
      this.tribute.detach(this.contentTarget);
    }
  }
}
